module.exports = __webpack_public_path__ + "static/media/pink_nebula_UP.cf6df36e.png";